module.exports = __webpack_public_path__ + "static/media/turks-and-caicos-islands.25f2be5f.svg";